import { combineReducers } from 'redux';
import isps from './isps';
import csrs from './csrs';
import pendingCsrs from './pendingCsrs';
import profile from './profile';
import timeEntries from './timeEntries';
import rollsheet from './rollsheet';

export default combineReducers({
  csrs,
  isps,
  pendingCsrs,
  profile,
  timeEntries,
  rollsheet,
});
